import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'
export class IndexKvSlider {
  constructor() {
    function navigation(slider) {
      let wrapper, dots, arrowLeft, arrowRight
      const kv = document.getElementById('js-index_kv')

      function markup(remove) {
        // wrapperMarkup(remove)
        dotMarkup(remove)
      }

      function removeElement(elment) {
        elment.parentNode.removeChild(elment)
      }
      function createDiv(className) {
        var div = document.createElement('div')
        var classNames = className.split(' ')
        classNames.forEach((name) => div.classList.add(name))
        return div
      }

      function wrapperMarkup(remove) {
        if (remove) {
          var parent = wrapper.parentNode
          while (wrapper.firstChild) parent.insertBefore(wrapper.firstChild, wrapper)
          removeElement(wrapper)
          return
        }
        wrapper = createDiv('navigation-wrapper')
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
      }

      function dotMarkup(remove) {
        if (remove) {
          removeElement(dots)
          return
        }
        dots = createDiv('dots')
        slider.track.details.slides.forEach((_e, idx) => {
          var dot = createDiv('dot')
          dot.addEventListener('click', () => slider.moveToIdx(idx))
          dots.appendChild(dot)
        })
        kv.appendChild(dots)
      }

      function updateClasses() {
        var slide = slider.track.details.rel
        Array.from(dots.children).forEach(function (dot, idx) {
          idx === slide ? dot.classList.add('is-act') : dot.classList.remove('is-act')
        })
      }

      slider.on('created', () => {
        markup()
        updateClasses()
      })
      slider.on('optionsChanged', () => {
        markup(true)
        markup()
        updateClasses()
      })
      slider.on('slideChanged', () => {
        updateClasses()
      })
      slider.on('destroyed', () => {
        markup(true)
      })
    }
    const kv = document.getElementById('kv-slider')
    if (!kv) return
    const slider = new KeenSlider(
      kv,
      {
        loop: true,
        defaultAnimation: {
          duration: 3000,
        },
        detailsChanged: (s) => {
          s.slides.forEach((element, idx) => {
            element.style.opacity = s.track.details.slides[idx].portion
          })
        },
        renderMode: 'custom',
      },
      [
        navigation,
        (slider) => {
          let timeout
          function clearNextTimeout() {
            clearTimeout(timeout)
          }
          function nextTimeout() {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
              slider.next()
            }, 2000)
          }
          slider.on('created', () => {
            slider.container.addEventListener('mouseover', () => {
              clearNextTimeout()
            })
            slider.container.addEventListener('mouseout', () => {
              nextTimeout()
            })
            nextTimeout()
          })
          slider.on('dragStarted', clearNextTimeout)
          slider.on('animationEnded', nextTimeout)
          slider.on('updated', nextTimeout)
        },
      ]
    )
  }
}
